















































import { defineComponent, ref } from '@vue/composition-api'
import SvgTreeOrg from '../src/tree.vue'
import { originData, linkNodeData } from './data/index'

export default defineComponent({
  components: {
    SvgTreeOrg,
  },
  setup() {
    const treeOrgRef = ref<InstanceType<typeof SvgTreeOrg> | null>(null)
    const direction = ref('vertical')
    const data = ref(originData)
    const linkData = ref(linkNodeData)
    const handleClick = () => {
      if (direction.value === 'vertical') {
        direction.value = 'horizontal'
      } else {
        direction.value = 'vertical'
      }
    }

    const lineWidth = ref(1)

    const lineArrow = ref({
      open: true,
      markerWidth: 5,
      markerHeight: 8,
      refX: 0,
      refY: 4,
      margin: 0
    })

    const lineCircle = ref({
      open: true,
      markerWidth: 8,
      markerHeight: 8,
      refX: 4,
      refY: 0,
      r: 3,
      strokeWidth: 2,
      margin: 4
    })

    const handleLineMouseover = (node: any) => {
      console.log('node', node)
    }

    const zoomable = ref(true)

    const hanldeZoom = (r: number) => {
      if (r > 0) {
        treeOrgRef.value?.zoomEnlarge()
      } else {
        treeOrgRef.value?.zoomNarrow()
      }
    }

    return {
      treeOrgRef,
      lineArrow,
      lineCircle,
      data,
      direction,
      zoomable,
      linkData,
      lineWidth,
      handleClick,
      handleLineMouseover,
      hanldeZoom,
    }
  }
})
